<template>
  <div class="col-sm-4 col-sm-offset-4">
    <h2>Déconnexion</h2>
    <p>
      Vous êtes maintenant déconnecté.
    </p>
    <p>
    Vous pouvez vous authentifier de nouveau au lien suivant:
    </p>
    <p>
      <router-link class="nav-link" active-class="active" to="/admin/authentification">Page de connexion</router-link>
    </p>
    <div class="alert alert-danger" v-if="error">
      <p>{{ error }}</p>
    </div>
  </div>
</template>

<script>
import auth from '@/auth'

export default {

  data() {
    return {
      error: ''
    }
  },
  created(){
    auth.logout()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/Deconnexion.vue